<template>
  <el-dialog :close-on-click-modal="false" title="批量搜索物流单号" :visible.sync="visible" width="600px" @close="close" @ok="ok">
    <div>
      <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="textarea">
      </el-input>
      <div style="text-align: right;margin-top: 20px;">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="ok">确定</el-button>
      </div>
    </div>
    
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      textarea: '',
      visible: false
    }
  },
  methods: {
    open(v){
      if(v) {
        this.textarea=v.join('\n')
      }
      this.visible = true
    },
    close(){
      this.visible = false

    },
    ok(){
      if(!this.textarea) {
        this.$message.warning('请输入')
        return
      }
      this.$emit('submit', this.textarea.split(/\n/).filter((v) => !!v || (v === 0)))
      this.close()
    }
  }
}
</script>
